import { Button, Dropdown, Row, Space, Switch } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import TableAntd from "components/elements/Table";
import { useCallback } from "react";
import { EditOutlined, MoreOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { formatDate } from "utils/formatter";
import { useSelector } from "react-redux";

const MasterDataManageRole = ({
    rolePaginationList = [],
    onEdit = () => { },
    onRoleStatusChange = () => { },
    onPageChange = () => { },
    pagination = {},
    isLoading = false
}) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { roles } = useSelector((state) => state.company);

    const columns = useCallback(
        () => {
            return [
                {
                    title: <div className="text-table">{t('setting_timesheet.label.roleId')}</div>,
                    dataIndex: "roleCode",
                    key: "roleCode",
                    width: 120
                },
                {
                    title: <div className="text-table">{t('setting_timesheet.label.roleName')}</div>,
                    dataIndex: "roleName",
                    key: "roleName",
                },
                {
                    title: <div className="text-table" style={{ textAlign: "center" }}>{t('employee.label.last_modified')}</div>,
                    dataIndex: "lastModified",
                    key: "lastModified",
                    render: (_, record) => {
                        const name =
                            i18n.language === "en" ? record?.lastModifiedBy?.fullNameEn : record?.lastModifiedBy?.fullName

                        return (
                            <span style={{ color: "#667085" }}>
                                {name}
                                <br />
                                {formatDate(record?.lastModifiedBy?.lastModifiedDate)}
                            </span>
                        );
                    }
                },
                {
                    title: (
                        <div className="text-table" style={{ textAlign: "center" }}>{t("status.entity")}</div>
                    ),
                    dataIndex: "statusFlag",
                    key: "statusFlag",
                    align: "center",
                    width: 120,
                    render: (text, record) => (
                        <Switch
                            checked={text === "ACTIVE" || record?.statusFlag === "ACTIVE"}
                            onChange={(checked) => onRoleStatusChange(checked, record)}
                        />
                    ),
                },
                {
                    title: "",
                    key: "action",
                    align: "center",
                    width: "80px",
                    render: (_, record) => (
                        <Space size="middle">
                            <Dropdown
                                menu={{
                                    items: [
                                        roles.includes("UPDATE_SETTING_TIMESHEET|MASTER_DATA") && {
                                            key: "1",
                                            onClick: () => {
                                                onEdit(record)
                                                navigate("/setting_timesheet/masterdata/edit_role")
                                            },
                                            label: `${t("action.edit")}`,
                                            icon: (
                                                <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                                            ),
                                        }
                                    ],
                                }}
                            >
                                <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                            </Dropdown>
                        </Space>
                    ),
                }
            ]
        }, [i18n, roles])

    return (
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
            {roles.includes("CREATE_SETTING_TIMESHEET|MASTER_DATA") && (
                <Row justify={"end"}>
                    <Button
                        type="primary"
                        style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", backgroundColor: "var(--button-color)" }}
                        icon={<CreateIcon style={{ fontSize: 16 }} />}
                        onClick={() => {
                            navigate("/setting_timesheet/masterdata/create_role")
                        }}
                    >
                        {t("setting_timesheet.label.create_role")}
                    </Button>
                </Row>)}

            <TableAntd
                columns={columns()}
                dataSource={rolePaginationList}
                onChange={onPageChange}
                loading={isLoading}
                pagination={{
                    ...pagination,
                    showTotal: (total, range) =>
                        t("paginate.description")
                            .replace("{min}", range[0])
                            .replace("{max}", range[1])
                            .replace("{total}", total),
                }}
            />
        </Space>
    )
}

export default MasterDataManageRole;